import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { graphql, StaticQuery } from "gatsby";
import { GlobalStyle } from "../Theme/components/GlobalStyle";
import { Header } from "../Header/Header";
import { Footer } from "../Footer/Footer";
import { styled } from "linaria/react";
import { muiTheme, theme } from "../Theme/Theme";
import SimpleReactLightbox from "simple-react-lightbox";

const StyledMain = styled.main`
  & > *:first-child {
    padding-top: ${theme.sizing.headerHeight};
  }

  & > *:last-child {
    margin-bottom: 8rem;
  }

  ${muiTheme.breakpoints.down("sm")} {
    max-width: 100vw;
    overflow: hidden;
  }
`;

const Layout = ({ children, lightHeader = false }) => {
  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
            }
          }
        }
      `}
      render={(data) => (
        <div className={GlobalStyle}>
          <Helmet
            title={data.site.siteMetadata.title}
            meta={[
              { name: "description", content: "Sample" },
              {
                name: "keywords",
                content: "sample, something",
              },
            ]}
          >
            <html lang="en" />
          </Helmet>
          <Header light={lightHeader} />
          <StyledMain>{children}</StyledMain>
          <Footer />
        </div>
      )}
    />
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
